import cplook from 'cplook'

$ ->
    # if $('#new_message_template').length > 0
        # cplook.editor.tinymce_enable($('#details_form'), $("#sms_tiny_mce"))
